import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.75, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const SectionLabel = ({ text }) => (
  <div className="flex items-center gap-3 mb-4">
    <span className="h-px w-10 bg-[#4CA6AF]" />
    <span className="text-base font-bold tracking-[0.25em] uppercase text-[#4CA6AF]">
      {text}
    </span>
  </div>
);
